import { FunctionComponent, useState, useCallback } from "react";
import { ReactSelectOption, ReactSelectOptions } from "../types";

import { FetchEmployerListResponse } from "../../api/APIEmployer";
import { EmployerAPI } from "../../context/TransferContext";
import { Autocomplete } from "@manifesthhqinc/ui-library";

interface EmployerSearchProps {
  value: { label: string; value: string } | undefined;
  onChange: (e?: ReactSelectOption) => void;
  error?: boolean;
  readOnly?: boolean;
  name: string;
  api: EmployerAPI;
  title?: string;
}

const EmployerSearch: FunctionComponent<EmployerSearchProps> = ({
  value,
  readOnly = false,
  name,
  onChange,
  api,
  title,
}) => {
  const [cachedEmployers, setCachedEmployers] = useState<FetchEmployerListResponse>([]);

  const getEmployerOptions = useCallback(
    async (userEmployerName: string): Promise<ReactSelectOptions> => {
      const employersResponse: FetchEmployerListResponse = await api.employer.fetchEmployersList(userEmployerName);
      const options = employersResponse.map((employer) => {
        return {
          label: employer.employerName,
          value: employer.employerId,
          employer,
        };
      });

      // The autocomplete input caches the getEmployerOptions request, so we have to cache the
      // results manually and then figure out which employer was selected
      setCachedEmployers([...cachedEmployers, ...employersResponse]);
      return options;
    },
    [cachedEmployers],
  );

  if (readOnly) {
    return <input type="text" value={value?.label || ""} />;
  }

  return (
    <Autocomplete
      name={name}
      onLoadOptions={getEmployerOptions}
      data-name="employerSearchAutocomplete"
      creatable
      title={title}
      value={value?.label}
      options={[]}
      onChange={onChange}
      size="large"
    />
  );
};

export default EmployerSearch;
